import { render } from "./GetPaymentPopup.vue?vue&type=template&id=0790c54b&scoped=true"
import script from "./GetPaymentPopup.vue?vue&type=script&lang=js"
export * from "./GetPaymentPopup.vue?vue&type=script&lang=js"

import "./GetPaymentPopup.vue?vue&type=style&index=0&id=0790c54b&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0790c54b"]])

export default __exports__